import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { LayoutPosition, styledLayout, styledReset } from '@pkg/primitives';

const parentBaseStyles = css`
    ${styledReset.borderBox}
    ${styledLayout.positionCover({ position: LayoutPosition.Fixed })}
    // TODO: This 'z-index' should not be tied to "nftFilterModal".
    z-index: ${({ theme }) => theme.zIndex.yatPage.nftFilterModal};
`;

export const StyledDrawer = styled(motion.div)`
    ${parentBaseStyles}
    --yat_drawer-bg-color: ${({ theme }) => theme.colors.darkBg};
    background-color: var(--yat_drawer-bg-color);
    overflow: hidden;
`;

export const Interior = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    // TODO: No idea how to use 'props' within a function argument
    // for styled-components... so I'm using a CSS variable instead.
    --yat_scrollbar-thumb-color: ${({ theme }) => theme.colors.purple};

    ${styledLayout.scrollbar({
        thumbColor: 'var(--yat_scrollbar-thumb-color)',
        trackColor: 'transparent',
    })}
`;

export const Backdrop = styled(motion.div)`
    ${parentBaseStyles}
    background-color: ${({ theme }) => theme.shades.black['30']};
`;
